export const BASE_URL = "http://154.53.40.41:8000";

export const DELETE_ACCOUNT_API = BASE_URL + "/web_delete_account";
